import { Button, Card, CardContent, Stack } from '@mui/material'
import { StoppageResponseDto } from '@operations/app/api'
import { formatStringDate } from '@operations/utils/format-date'
import { useTranslate } from '@tolgee/react'
import { Tile, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  stoppage: StoppageResponseDto
  onEdit: (stoppage: StoppageResponseDto) => void
}
export const StoppageCard = observer(({ stoppage, onEdit }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Card onClick={() => onEdit(stoppage)} data-cy='stoppage-card' sx={{ cursor: 'pointer' }}>
      <CardContent>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Stack
            gap={theme.customSpacing.s}
            flexDirection={{ xs: 'column', md: 'row' }}
            alignItems={{ xs: 'flex-start', md: 'center' }}
          >
            <Tile label={t('reason', 'Reason')} value={stoppage.stoppageReason.name} />
            <Tile
              label={t('startingTime', 'Starting time')}
              value={formatStringDate(stoppage.from)}
            />
          </Stack>

          <Button color='inherit'>{t('edit', 'Edit')}</Button>
        </Stack>
      </CardContent>
    </Card>
  )
})
